<div class="header">
  <h2>{{ "pages.integrations.title" | translate }}</h2>
</div>

<div class="groups" alAnchor="integrations.groups">
  @for (group of cardGroups; track group.group) {
    <div class="group">
      <h4 class="group-label">{{ group.labelKey | translate }}</h4>
      <div class="container">
        @for (card of group.cards; track $index) {
          <app-integration-card [data]="card"></app-integration-card>
        }
      </div>
    </div>
  }
</div>
